module.exports = __webpack_public_path__ + "img/dsci0161.d3a14602.jpg";